import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

@Index(
	'idx_custom_field_owner_entity_key',
	['ownerUserId', 'entityType', 'fieldKey'],
	{
		unique: true,
	},
)
@Index('idx_custom_field_entity_active', ['entityType', 'isActive'], {})
@Entity('custom_field_definition')
export class CustomFieldDefinitionEntity extends BaseEntity {
	@Column('varchar', { name: 'fieldKey', length: 60 })
	public fieldKey!: string;

	@Column('varchar', { name: 'entityType', length: 50 })
	public entityType!: string;

	@Column('varchar', { name: 'label', length: 255 })
	public label!: string;

	@Column('varchar', { name: 'fieldType', length: 50 })
	public fieldType!: string;

	@Column('varchar', { name: 'sqlColumnType', length: 100 })
	public sqlColumnType!: string;

	@Column('tinyint', { name: 'isIndexed', width: 1, default: () => "'0'" })
	public isIndexed!: boolean;

	@Column('tinyint', { name: 'isActive', width: 1, default: () => "'1'" })
	public isActive!: boolean;

	@Column('text', { name: 'defaultValue', nullable: true })
	public defaultValue!: string | null;

	@Column('tinyint', { name: 'isRequired', width: 1, default: () => "'0'" })
	public isRequired!: boolean;

	@Column('json', {
		name: 'validationRules',
		nullable: true,
		comment: 'JSON object with validation rules (min, max, pattern, etc.)',
	})
	public validationRules!: Record<string, unknown> | null;

	@Column('json', {
		name: 'allowedRoles',
		nullable: true,
		comment: 'Array of role IDs that can see this field. Empty = all roles',
	})
	public allowedRoles!: Array<number> | null;

	@Column('int', { name: 'sortOrder', default: () => "'0'" })
	public sortOrder!: number;

	@Column('json', {
		name: 'selectOptions',
		nullable: true,
		comment: 'Array of options for select/multiselect field types',
	})
	public selectOptions!: Array<{ value: string; label: string }> | null;
}
